import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./App";
import { msalConfig } from "./auth/authConfig";
import { AppProviders } from "./AppProviders";

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
  if (!msalInstance.initialized) {
    await msalInstance.initialize();
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <AppProviders msalInstance={msalInstance}>
      <App />
    </AppProviders>
  );
};

initializeMsal();
